<template>
  <div class="explanation-content">
    <p class="explanation-gist">{{ explanation.gist }}</p>

    <ul v-if="points.length" class="hairline-list">
      <li v-for="point in points" :key="point.original">
        <strong class="point-phrase">{{ point.original }}</strong>
        <p>{{ point.note }}</p>
      </li>
    </ul>

    <section v-for="kind in answeredKinds" :key="kind" class="follow-up-answer">
      <h3>{{ $t(`sentenceExplanation.followUps.${kind}`) }}</h3>
      <ul class="hairline-list">
        <li v-for="(item, index) in followUps[kind].items" :key="index">
          <strong>{{ item.text }}</strong>
          <p v-if="item.note">{{ item.note }}</p>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
export default {
  name: 'SentenceExplanationContent',
  props: {
    explanation: { type: Object, required: true },
    followUps: { type: Object, default: () => ({}) },
  },
  computed: {
    points() {
      return this.explanation.points || []
    },
    answeredKinds() {
      return ['grammar', 'rephrase', 'examples'].filter((kind) => this.followUps[kind]?.items?.length)
    },
  },
}
</script>

<style scoped>
.explanation-content { display: grid; gap: var(--space-6); }
.explanation-content > * { animation: content-rise 520ms var(--ease-spring) both; }
.explanation-content > :nth-child(2) { animation-delay: 70ms; }
.explanation-content > :nth-child(3) { animation-delay: 140ms; }
.explanation-content > :nth-child(n + 4) { animation-delay: 210ms; }
.explanation-gist { margin: 0; color: var(--color-text); font-size: 1.02rem; line-height: 1.65; letter-spacing: -0.005em; }
.hairline-list { margin: 0; padding: 0; list-style: none; border-top: 1px solid var(--color-border); }
.hairline-list li { display: grid; gap: 3px; padding: var(--space-3) 0 14px; border-bottom: 1px solid var(--color-border); }
.hairline-list strong { color: var(--color-text); font-size: 0.94rem; font-weight: 600; line-height: 1.5; letter-spacing: -0.005em; overflow-wrap: anywhere; }
.point-phrase { justify-self: start; background: linear-gradient(transparent 64%, color-mix(in srgb, var(--signal-marker) 50%, transparent) 0); }
.hairline-list p { margin: 0; color: var(--color-text-muted); font-size: 0.86rem; line-height: 1.6; }
.follow-up-answer { display: grid; gap: var(--space-2); }
.follow-up-answer h3 { margin: 0; color: var(--color-text-subtle); font-size: 0.75rem; font-weight: 500; letter-spacing: 0.02em; }
@keyframes content-rise { from { opacity: 0; transform: translateY(8px); } }
@media (prefers-reduced-motion: reduce) { .explanation-content > * { animation: none; } }
</style>
